<div id="newLogoContent" class="tab-pane active">

  <div class="tab-content" id="newPromoTabs-content">
    <form [formGroup]="promoContentgrpForm">
      <div id="promoContentRow" class="row">
        <div id="promoContentFormGrp" class="form-group col-md-4">
          <label for="publishedName"><span i18n="@@global.tab-text.published-name">Published Name</span><span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="publishedName" placeholder={{publishNamePlaceholder}}
            formControlName="publishedName" name="publishedName" maxlength="50" required />
          <div id="promoContentSubmittedName" *ngIf="isSubmitted && promoContentgrpForm?.controls?.publishedName?.value.trim() === ''"
            class="formfield_err_msg"><span i18n="@@create-promo-content.publish-name.required-msg">This is a required field.</span>
          </div>
          <div id="promoContentSubmittedMax" *ngIf="isSubmitted && promoContentgrpForm?.controls?.publishedName?.errors?.maxlength" class="formfield_err_msg">
            <span i18n="@@create-promo-content.publish-name.max-length-msg">Published name may be up to 50 characters long.</span></div>
        </div>
        <div id="publishTimeFormGrp" class="form-group col-md-8">
          <!-- TODO -->
          <!-- <label for="publishedTimeStamp">Publish Date & Time<span class="text-danger">*</span></label>
          <div container="body" [ngbPopover]="dateTimePicker" placement="bottom-right" [autoClose]="false"
            popoverTitle="Publish Date/Time">
            <input class="form-control" value="{{dateTimeValue}}" formControlName="publishedTimeStamp"
              id="publishedTimeStamp">
            <em class="date_icon cursor-pointer"></em>
          </div>
          <em class="err_icon"></em>
          <div *ngIf="isPublishedDateInCorrect" class="formfield_err_msg"> Published date should not be less than today
          </div>
          <span class="formfield_err_msg"></span>
          <ng-template #dateTimePicker>
            <iposcen-datetimepicker-popover (currentDateTime)="getCurrentDate($event)"
              (selectedDateTime)="getSelectedTime($event)" popoverTitle="Publish" buttonText="Use Current Date & Time">
            </iposcen-datetimepicker-popover>
          </ng-template> -->
          <label for="publishedTimeStamp"><span i18n="@@create-promo-content.publish-date-time">Publishing Date and Time</span></label>
          <div id="publishDateSection" class="publishDate-Section">
            <div id="publishDateCustomDatepicker">
              <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
                [checked]="!isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now')" />
              <label for="now"><span i18n="@@create-promo-content.publish-date.now-msg">Now</span></label>
            </div>
            <div id="publishCustomDatePicker" class="custom-datepicker">
              <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input"
                id="publish-date-custom" [checked]="isPublishDateCustomDatepicker"
                (click)="selectCustomPublishDate('custom')" />
              <label for="publish-date-custom" *ngIf="!isPublishDateCustomDatepicker">
                <span i18n="@@create-promo-content.publish-date.custom-msg">Custom</span></label>
              <div id="publishDateCustomDatepicker" *ngIf="isPublishDateCustomDatepicker">
                <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')" (getDateTimeZoneData)="getLogoContentPublishDate($event)"
                (isTimeZoneSelected)="checkTimeZone($event,'publish')" [publishDateInfo]="editPublishDateInfo">
                </iposcen-date-time-zone>
              </div>
            </div>
          </div>
          <div id="customPublishDateCorrect" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected" class="formfield_err_msg">
            <span i18n="@@create-promo-content.publish-date.custom-validation-msg">Please select the publishing date and time zone</span>
          </div>
        </div>
       </div>
      <div id="internalNameRow" class="row">
        <div id="internalNameFormGrp" class="form-group col-md-4">
          <label for="internalName">
            <span i18n="@@global.tab-text.published-name">Internal Name</span>
          </label>
          <input type="text" class="form-control" id="internalName" placeholder={{internalNamePlaceholder}}
            formControlName="internalName" maxlength="50" />
        </div>
        <div id="publishedTimeStampFormGrp" class="form-group col-md-8">
          <!-- TODO -->
          <!-- <label for="publishedTimeStamp">Expiry Date & Time<span class="text-danger">*</span></label>
          <div container="body" [ngbPopover]="dateTimePickereExpiry" placement="top-right" container="body"
            [autoClose]="false" popoverTitle="Expiry Date/Time">
            <input class="form-control" value="{{expiryDateTime}}" formControlName="expiryTimeStamp"
              id="expiryTimeStamp">
            <em class="date_icon cursor-pointer"></em>
            <div *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"> Expiry should not be less than published date
            </div>
          </div>
          <em class="err_icon"></em>
          <span class="formfield_err_msg"></span>
          <ng-template #dateTimePickereExpiry>
            <iposcen-datetimepicker-popover (currentDateTime)="getExpiryNever($event)"
              (selectedDateTime)="getExpirySelectedTime($event)" popoverTitle="Expiry" buttonText="Expire Never">
            </iposcen-datetimepicker-popover>
          </ng-template> -->
          <label for="publishedTimeStamp"><span i18n="@@create-promo-content.expire-date-time">Expiration Date and Time</span></label>
          <div id="publishTimeStampSection" class="publishDate-Section">
            <div id="publishTimeStampRadio">
              <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
                [checked]="!isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never')" />
              <label for="never"> <span i18n="@@create-promo-content.expire-date.now-msg">Never</span></label>
            </div>
            <div id="publishTimeStampCustomDatePicker" class="custom-datepicker">
              <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input" id="expiry-custom"
                [checked]="isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom')" />
              <label for="expiry-custom" *ngIf="!isExpiryDatePicker"> <span i18n="@@create-promo-content.publish-date.custom-msg">Custom</span></label>
              <div id="publishTimeStampExpiryDatePicker" *ngIf="isExpiryDatePicker">
                <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')" (getDateTimeZoneData)="getLogoContentExpiryDate($event)"
                (isTimeZoneSelected)="checkTimeZone($event,'expiry')" [expiryDateInfo]="editexpiryDateInfo">
                </iposcen-date-time-zone>
              </div>
            </div>
          </div>
          <div id="publishTimeStampExpiredDateIncorrect" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"><span i18n="@@create-promo-content.expiry-to-publish-check-msg">Expiration date should not be before publishing date.</span>
          </div>
          <div  id="publishTimeStampCustomExpiryDateCorrect" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg"><span i18n="@@create-promo-content.expiry-to-publish-required-msg">Please select expiration date and time zone.</span>
          </div>
        </div>
      </div>
      <div id="applyContentRow" class="row">
        <div id="applyContentFormGrp" class="form-group col-md-6">
          <label for=""><span i18n="@@create-promo-content.apply-content-group-to-label">Apply content group to</span></label><br/>
          <button type="button" class="btn btn-primary left_icon_btn gtmFormFactorPromo" (click)="openFormFactorsModal()">
            <img src="assets/images/laptop_icon.svg" alt="select form factors" />
            <span i18n="@@create-promo-content.select-form-factor">Select Form Factors</span>
          </button>
          <iposcen-form-factors #formFactorsModal [contentName]="selectedFormFactors"
            (applyFormFactor)="applyFormFactor($event)"></iposcen-form-factors>
          <div id="selectedFormFactors" *ngIf="selectedFormFactors" class="selected_factors">
            <div id="applyFormFactorSection">
              <div id="applyFormFactorDevicesSection">
                <div id="applyFormFactorDeviceTypes" class ="font-bold inline-block"><span >{{deviceTypes}}</span>: </div>
                <div id="selectedFormFactorsdevices" class="inline">&nbsp;<span>{{ selectedFormFactors?.devices}} </span></div>
              </div>
               <div id="applyFormFactorManufacturesSection">
                <div id="applyFormFactorManufactures" class ="font-bold inline-block"><span >{{manufacturers}}</span>: </div>
                <div id="selectedFormFactorsManufactures" class="inline"> &nbsp;<span>{{ selectedFormFactors?.manufacturer}}</span></div></div>
              <div id="applyFormFactorProcessorsSection">
                <div id="applyFormFactorProcessors" class ="font-bold inline-block"><span>{{processors}}</span>: </div>
                <div id="selectedFormFactorsProcessors" class="inline">&nbsp; <span>{{ selectedFormFactors?.processors}} </span></div>
              </div>
              <div id="applyFormFactorGenerationSection">
                <div id="applyFormFactorGeneration" class ="font-bold inline-block"><span >{{generation}}</span>: </div>
                <div id="selectedFormFactorsGeneration" class="inline">&nbsp;<span>{{ selectedFormFactors?.generations}} </span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div id="btnWrapper" class="button-wrapper" style="justify-content: flex-end;">
    <button type="button" (click)="cancel()" class="btn btn-outline-primary gtmCancelPromo">
      <span i18n="@@create-promo-content.cancel">Cancel</span>
    </button>
    <button type="button" (click)="onAdd()" class="btn btn-primary gtmSavePromo"
      [disabled]="promoContentgrpForm?.controls?.publishedName?.value?.trim() === ''">
      <span class="gtmSavePromo" i18n="@@create-promo-content.save-and-proceed">Save and Proceed</span>
    </button>
  </div>
</div>
